import { create } from 'zustand';

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastState {
  visible: boolean;
  message: string;
  type: ToastType;
  show: (message: string, type?: ToastType, durationMs?: number) => void;
  showToast: (message: string, type?: ToastType, durationMs?: number) => void; // 添加别名以向后兼容
  hide: () => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  visible: false,
  message: '',
  type: 'info',
  show: (message, type = 'info', durationMs = 1800) => {
    set({ visible: true, message, type });
    if (durationMs > 0) {
      setTimeout(() => set({ visible: false }), durationMs);
    }
  },
  showToast: (message, type = 'info', durationMs = 1800) => {
    get().show(message, type, durationMs);
  },
  hide: () => set({ visible: false }),
}));
